import { Injectable } from '@angular/core';
import { SearchItem } from '../../../models/search-item';
import { EntitySearchItemsAction } from '../../entity-search/entity-search-item/action/entity-search-items.action';
import { TaskSearchItemsAction } from '../../task-search/task-search-item/action/task-search-items.action';
import { SearchItemsAction } from '../../document-search/document-search-item/action/search-items.action';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractSearchItemsService {

  protected abstract getSearchItemsAction(): SearchItemsAction | EntitySearchItemsAction | TaskSearchItemsAction;

  public addItem(item: SearchItem): void {
    const searchItemsAction: SearchItemsAction | EntitySearchItemsAction | TaskSearchItemsAction = this.getSearchItemsAction();
    searchItemsAction.addSearchItemStarted();
    try {
      if (item === undefined || item === null) {
        throw new ErrorEvent('ERROR');
      }
      searchItemsAction.addSearchItemSucceeded(item);
    } catch (error) {
      searchItemsAction.addSearchItemFailed(error);
    }
  }

  public deleteItem(id: number | SearchItem): void {
    const searchItemsAction: SearchItemsAction | EntitySearchItemsAction | TaskSearchItemsAction = this.getSearchItemsAction();
    searchItemsAction.removeSearchItemStarted();
    try {
      if (id === undefined || id === null) {
        throw new ErrorEvent('ERROR');
      }
      let searchItem;
      if (id instanceof SearchItem) {
        searchItem = id;
      } else {
        searchItem = new SearchItem(id, '', '', '', true);
      }
      searchItemsAction.removeSearchItemSucceeded(searchItem);
    } catch (error) {
      searchItemsAction.removeSearchItemFailed(error);
    }
  }

  public removeAllSearchItems(): void {
    const searchItemsAction: SearchItemsAction | EntitySearchItemsAction | TaskSearchItemsAction = this.getSearchItemsAction();
    searchItemsAction.removeAllSearchItemsSucceeded();
  }
}
